import { fade, makeStyles, withStyles } from '@material-ui/core/styles'
import { StepConnector } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  StepperWrapper: {
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 0)
    },
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(0, -1),
      '& .MuiStepContent-root, & .MuiStepConnector-vertical': {
        marginLeft: theme.spacing(2.75)
      }
    }
  },
  invoiceStepWrapper: {
    width: '100%',
    padding: theme.spacing(3, 3, 5),
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '&.step2': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    '&.in-dialog': {
      padding: theme.spacing(0)
    }
  },
  AddressCollapseWrapper: {
    backgroundColor: theme.palette.colors.body
  },
  IssuerReceiverWrapper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    width: '100%',
    '&:not(.in-dialog)': {
      [theme.breakpoints.up('lg')]: {
        '&:not(.row)': {
          width: '50%'
        }
      }
    }
  },
  ReceiverAddressWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  IssuerReceiverHeaderWrapper: {
    margin: theme.spacing(0, 'auto', 1),
    boxShadow: `0 0 12px ${fade(theme.palette.primary.dark, 0.30)}`,
    backgroundColor: 'transparent',
    minHeight: 56,
    '& p': {
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.primary.dark,
      fontSize: theme.typography.pxToRem(16)
    },
    '& .MuiAccordionSummary-expandIcon svg': {
      color: theme.palette.primary.dark,
      fontSize: theme.typography.pxToRem(32)
    },
    '&.Mui-expanded': {
      minHeight: 56
    },
    '& .MuiAccordionSummary-content': {
      margin: theme.spacing(1)
    },
    '&.receiver': {
      boxShadow: `0 0 16px ${fade(theme.palette.secondary.dark, 0.30)}`,
      '& p, & .MuiAccordionSummary-expandIcon svg': {
        color: theme.palette.secondary.dark
      }
    }
    // &.in-dialog
  },
  IssuerReceiverHeader: {
    '& p': {
      display: 'flex',
      justifyContent: 'center',
      '& svg': {
        marginRight: theme.spacing(0.5)
      }
    }
  },
  IssuerReceiverDetailsWrapper: {
    padding: theme.spacing(2),
    marginLeft: theme.spacing(2),
    borderLeft: `1px dashed ${theme.palette.primary.dark}`,
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    width: `calc(100% - ${theme.spacing(2)}px)`,
    '&.receiver': {
      borderLeft: `1px dashed ${theme.palette.secondary.main}`
    },
    '&.in-dialog': {
      borderLeft: 0,
      width: '100%',
      marginLeft: theme.spacing(0),
    }
  },
  IssuerReceiverDetailsContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    width: '100%'
  },
  Optional: {
    color: theme.palette.grey['500'],
    marginLeft: theme.spacing(0.75)
  },

  optionWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%'
  },
  optionContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    marginLeft: theme.spacing(0.5)
  },
  optionParent: {
    color: theme.palette.grey['500'],
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    fontWeight: theme.typography.fontWeightSemiBold,
    '& span:not(:last-child)': {
      marginRight: theme.spacing(1)
    }
  },
  option: {
    color: theme.palette.primary.dark,
    fontWeight: theme.typography.fontWeightBold,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  optionID: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minWidth: '50%',
    marginRight: theme.spacing(3),
    color: theme.palette.primary.dark,
    fontWeight: theme.typography.fontWeightBold,
    '& span': {
      color: theme.palette.common.black,
      fontWeight: theme.typography.fontWeightRegular
    }
  },
  optionTotal: {
    color: theme.palette.secondary.main,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    fontSize: theme.typography.pxToRem(24)
  },
  dialogActionWrapper:{
    width: '100%',
  },
  dialogActionButtonsWrapper: {
    padding: theme.spacing(2),
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderTop: `1px solid ${fade(theme.palette.colors.border, 0.8)}`,
    justifyContent: 'flex-end',
    '& button': {
      lineHeight: 1.3,
      padding: theme.spacing(1.25, 2.5),
      borderRadius: theme.spacing(1.25),
      '& svg': {
        marginRight: theme.spacing(0.5)
      },
      [theme.breakpoints.up('sm')]: {
        minWidth: 140
      },
      '& + button': {
        marginLeft: theme.spacing(2)
      }
    }
  },
  referenceWrapper:{
    display: 'flex',
    width: '100%',
    alignItems: 'flex-start',
    '& > button': {
      textTransform: 'none',
      marginTop: theme.spacing(4.5),
      borderTopLeftRadius: theme.spacing(0),
      borderBottomLeftRadius: theme.spacing(0),
      marginLeft: theme.spacing(-0.25),
      height: 40
    },
    '& .MuiOutlinedInput-root':{
      borderTopRightRadius: theme.spacing(0),
      borderBottomRightRadius: theme.spacing(0)
    }
  }
}))

export const InvoiceStepIconStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    minWidth: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    padding: 0,
    alignItems: 'center'
  },
  active: {
    backgroundImage:
      `linear-gradient( 136deg, ${fade(theme.palette.primary.main, 1)} 0%, ${fade(theme.palette.primary.dark, 1)} 100%)`,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  completed: {
    backgroundImage:
      `linear-gradient( 136deg, ${fade(theme.palette.primary.main, 1)} 0%, ${fade(theme.palette.primary.dark, 1)} 100%)`
  }
}))

export const InvoiceStepsConnector = withStyles((theme) => ({
  alternativeLabel: {
    top: 22
  },
  active: {
    '& $line:before': {
      width: '100%'
    }
  },
  completed: {
    '& $line:before': {
      width: '100%'
    }
  },
  line: {
    height: 4,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    position: 'relative',
    '&:before': {
      content: '""',
      width: 0,
      left: 0,
      top: 0,
      display: 'block',
      height: '100%',
      zIndex: 0,
      transition: 'all 0.3s ease-in-out',
      backgroundImage:
        `linear-gradient( 136deg, ${fade(theme.palette.primary.main, 1)} 0%, ${fade(theme.palette.primary.dark, 1)} 100%)`
    }
  }
}))(StepConnector)